import { 
    apiRequest,
    standarKompetensiList,
    standarKompetensiActive,
    standarKompetensiInactive,
    standarKompetensiDetail
} from "../../../../../services/adapters/base"

class IndexRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", standarKompetensiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", standarKompetensiInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", standarKompetensiActive, {
            body: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest('get', standarKompetensiDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }


}

export default IndexRepository
